import { IConfigurationBase, IConfigSource } from './types';

/**
 * loads the configuration file and parses it
 * @param path url of the path where configuration file is located
 */
export function loadConfiguration<TConfig extends IConfigurationBase>(path: string): Promise<TConfig> {
    return fetch(path).then(i => (i.json()));
}

export function isProduction(environment: string) {
    return environment === 'production';
}

export const ConfigSource = {
    from: <TConfig extends IConfigurationBase>(config: TConfig): IConfigSource<TConfig> => ({
        load: () => Promise.resolve(config)
    }),
    fromFile: <TConfig extends IConfigurationBase>(path: string): IConfigSource<TConfig> => ({
        load: () => loadConfiguration(path)
    })
};
